<template>
  <span class="loading-spinner" :style="styleVars"></span>
</template>

<script>
export default {
  name: "loading-spinner",
  props: {
    size: Number
  },
  data: () => ({
    defaultSize: 20
  }),
  computed: {
    styleVars() {
      let spinnerSize;

      if (this.size != undefined) {
        spinnerSize = this.size;
      } else {
        spinnerSize = this.defaultSize;
      }

      return "width: " + spinnerSize + "px;" + "height: " + spinnerSize + "px;";
    }
  }
};
</script>

<style lang="scss" scoped>
.loading-spinner {
  border: 2px solid $blue-light;
  border-left-color: transparent;
  border-radius: 50%;
  display: inline-block;
  margin: auto;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  animation: spin 1s infinite linear;
}

@keyframes spin {
  0% {
    transform: rotateZ(0);
  }

  100% {
    transform: rotateZ(360deg);
  }
}
</style>
